import React from 'react'
import { IndexRunResult } from '@feedyou/utils'
import { toast } from 'react-toastify'

import { feedbotToast, Subtitle } from '../../lib/feedbotToast'

export const toastNotifyJoinedConnectionInfo = (collaboratorUsername: string) => {
  const id = 'joinedConnectionInfo'

  const title = 'Someone has joined you'

  const content = (
    <>
      <Subtitle>
        <strong>{collaboratorUsername}</strong> has joined you in editing.
      </Subtitle>
      ⚠️ Changes made by all co-authors will be merged into the same version during saving.
    </>
  )

  feedbotToast.info({ title, content, id })
}

export const toastNotifySaveChangesError = () => {
  const id = 'saveChangesError'

  const title = 'Unable to save'

  const content =
    'Sorry, it was not possible to apply your last change, probably due to a conflict with another editing user. So please, check your changes and try to save them once again.'

  feedbotToast.info({ title, content, id })
}

const YOU_OPENED_EXCLUSIVE_UI_ID = 'youOpenedExclusiveUi'

export const toastNotifyYouOpenedExclusiveUi = () => {
  const id = YOU_OPENED_EXCLUSIVE_UI_ID

  const title = 'You locked the bot for others'

  const content =
    'You cannot edit the bot in the Conversation / NLP Designer and the JSON or Settings simultaneously.'

  feedbotToast.warning({
    title,
    content,
    id,
    config: {
      autoClose: false,
      position: 'top-right'
    }
  })
}

export const dismissedOpenedExclusiveUiToast = () => toast.dismiss(YOU_OPENED_EXCLUSIVE_UI_ID)

export async function toastNotifyIndexingDone(
  modelId: string,
  { documentsCount, failedDocumentsCount }: IndexRunResult = {} as any
): Promise<void> {
  if (failedDocumentsCount > 0) {
    return feedbotToast.warning({
      id: `indexing_error_${modelId}`,
      title: 'Encountered errors during indexing',
      content: (
        <div>
          The indexing for model {modelId} was completed, but {failedDocumentsCount} out of{' '}
          {documentsCount} documents failed to index.
          <br />
          <br />
          You can see indexing run details in "knowledge" tab under model {modelId}
        </div>
      )
    })
  }

  feedbotToast.success({
    title: 'Indexing completed successfully',
    id: `indexing_done_${modelId}`,
    content: (
      <div>
        Indexing of {documentsCount} documents for model {modelId} was completed successfully.
        <br />
        <br />
        You can see indexing run details in "knowledge" tab under model {modelId}
      </div>
    )
  })
}
